import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

import App from './App.vue';
import store from './store';
import HomePage from './pages/HomePage.vue';
import SharePlanPage from './pages/SharePlanPage.vue';

const routes = [
  { path: '/', component: HomePage },
  { path: '/share-plan', component: SharePlanPage },
  {
    path: '/app-store',
    component: HomePage,
    beforeEnter() {
      window.location.href = 'https://apps.apple.com/it/app/gym-buddy-tracker/id1659216618?l=en';
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const app = createApp(App);
app.use(store);
app.use(router);
app.mount('#app');
